<form *ngIf="childEntities.length" [formGroup]="deviceForm" (ngSubmit)="save()">
  <div class="row p-4">
    <div class="col-6">
      <div class="row mb-3" *ngIf="device.id">
        <label [for]="'id-' + device.id" class="col-sm-5 col-form-label">{{ 'ENTITY.DATABASE_ID' | translate }}</label>
        <div class="col-sm-7">
          <input type="text" class="form-control-plaintext" [id]="'id-' + device.id" formControlName="id" readonly>
        </div>
      </div>

      <div class="row mb-3">
        <label [for]="'deviceTypeId-' + device.id" class="col-sm-5 col-form-label">{{ 'COMMON.TYPE' | translate }}
          *</label>
        <div class="col-sm-7">
          <select [class]="action === 'create' ? 'form-select' : 'form-control-plaintext'"
            [id]="'deviceTypeId-' + device.id" formControlName="deviceTypeId">
            <option value="1">{{ 'DEVICE.SCANNER_HEAD' | translate }}</option>
            <option value="2">{{ 'DEVICE.SCANNER_COLUMN' | translate }}</option>
            <option value="3" disabled>{{ 'DEVICE.VR_HEADSET' | translate }}</option>
          </select>
          <hbo-control-messages [control]="deviceForm.get('deviceTypeId')!"></hbo-control-messages>
        </div>
      </div>

      <div class="row mb-3">
        <label [for]="'snMac-' + device.id" class="col-sm-5 col-form-label">{{ 'DEVICE.SN_MAC' | translate }} *</label>
        <div class="col-sm-7">
          <input type="text"
            [class]="action === 'create' ? 'form-control' : 'read-only'"
            [id]="'snMac-' + device.id" [formControlName]="action === 'create' ? 'snMac' : 'serialNumber'">
          <hbo-control-messages [control]="action === 'create' ? deviceForm.get('snMac')!: deviceForm.get('serialNumber')!"></hbo-control-messages>
        </div>
      </div>

      <div class="row mb-3">
        <label [for]="'entityId-' + device.id" class="col-sm-5 col-form-label">{{ 'COMMON.ENTITY' | translate }}
          *</label>
        <!--<div class="col-sm-7">
          <select class="form-select" [id]="'entityId-' + device.id" formControlName="entityId">
            <option [value]="entity.id" *ngFor="let entity of entities">{{ entity.name }}</option>
          </select>
          <hbo-control-messages [control]="deviceForm.get('entityId')!"></hbo-control-messages>
        </div>-->
        <div *ngIf="action !== 'create' && device.deviceTypeId === 3" class="col-sm-7 align_middle">
          {{entity.name}}
        </div>
        <div *ngIf="(action === 'create' && entities.length) || ( entity && entities.length)" class="col-sm-7">
          <!--<select class="form-select" [id]="'parentEntityId-' + entity.id" formControlName="parentEntityId">
            <ng-container *ngFor="let parentEntity of parentEntities">
              <option [value]="parentEntity.id"
                *ngIf="parentEntity.entityTypeId < utils.toNumber(entityForm.controls.entityTypeId?.value)">{{
                parentEntity.name }}</option>
            </ng-container>
          </select>-->
          <!--<hbo-single-select-multi-level
            *ngIf="action === 'create' || (action !== 'create' && device.deviceTypeId !== 3)" [tree]="entities"
            [userEntity]="user" [typeData]="action === 'create' ?  'newDevice': 'device'"
            [max]="action === 'create' ? reactiveToRole : entity.entityTypeId" [selection]="entity"
            formControlName="entityId">
          </hbo-single-select-multi-level>-->
          <app-basic-virtual-scroll *ngIf="selectorVisible && configSvc.currentConfigValue.childEntities && (action === 'create' || (action !== 'create' && device.deviceTypeId !== 3))"
            [customTreeNode]="entities" [entityId]="action !== 'create' ? persistEntityId : deviceForm.get('entityId')!.value" [currentEntityId]="deviceForm.get('entityId')!.value | toString" (callback)="onChange($event,'device')"
            [typeData]="action === 'create' ? 'newDevice': 'device'"></app-basic-virtual-scroll>
            
          <hbo-control-messages [control]="deviceForm.get('entityId')!"></hbo-control-messages>
        </div>
      </div>

      <div class="row mb-3" *ngIf="user.roleId === 1">
        <label [for]="'createdAt-' + device.id" class="col-sm-5 col-form-label">{{ 'DEVICE.CREATION_DATE' | translate }}
          *</label>
        <div class="col-sm-7">
          <input type="date" class="form-control" [id]="'createdAt-' + device.id" formControlName="createdAt" [ngClass]="{'read-only':action === 'edit'}"><!---->
          <hbo-control-messages [control]="deviceForm.get('createdAt')!"></hbo-control-messages>
        </div>
      </div>

      <div class="row mb-3" *ngIf="deviceForm.get('deviceTypeId')!.value !== '3' && user.roleId === 1">
        <label [for]="'soldAt-' + device.id" class="col-sm-5 col-form-label">{{ 'DEVICE.SOLD_DATE' | translate
          }}</label>
        <div class="col-sm-7">
          <input type="date" class="form-control" [id]="'soldAt-' + device.id" formControlName="soldAt">
          <hbo-control-messages [control]="deviceForm.get('soldAt')!"></hbo-control-messages>
        </div>
      </div>

      <small>* {{ 'COMMON.MANDATORY' | translate }}</small>
    </div>

    <div class="col-6" *ngIf="deviceForm.get('deviceTypeId')?.value && user.roleId <=3">
      <h4 class="pb-2 mb-3 border-bottom fw-bold">
        <ng-container *ngIf="deviceForm.get('deviceTypeId')?.value === '1'">{{ 'DEVICE.SCANNER_HEAD' | translate
          }}</ng-container>
        <ng-container *ngIf="deviceForm.get('deviceTypeId')?.value === '2'">{{ 'DEVICE.SCANNER_COLUMN' | translate
          }}</ng-container>
        <ng-container *ngIf="deviceForm.get('deviceTypeId')?.value === '3'">{{ 'DEVICE.VR_HEADSET' | translate
          }}</ng-container>
        {{ 'COMMON.DETAILS' | translate }}
      </h4>
      <div class="row mb-3">
        <label [for]="'hardwareVersion-' + device.id" class="col-sm-5 col-form-label">{{ 'DEVICE.HARDWARE_VERSION' |
          translate }}</label>
        <div *ngIf="deviceForm.get('deviceTypeId')!.value === '3'" class="col-sm-7">
          <input type="text" class="form-control" [id]="'hardwareVersion-' + device.id"
            formControlName="hardwareVersion" [ngClass]="{'read-only':action === 'edit'}">
        </div>
        <div *ngIf="deviceForm.get('deviceTypeId')!.value !== '3'" class="col-sm-7">
          <select class="form-select" [id]="'hardwareVersion-' + device.id" formControlName="hardwareVersion" [ngClass]="{'read-only':action === 'edit'}">
            <option>PR23</option>
            <option>PR22</option>
            <option>PR21</option>
            <option>PR20</option>
            <option>PR19</option>
            <option>Beta</option>
            <option>Alpha2</option>
          </select>
          <hbo-control-messages [control]="deviceForm.get('hardwareVersion')!"></hbo-control-messages>
        </div>
      </div>

      <div class="row mb-3" *ngIf="deviceForm.get('deviceTypeId')?.value === '1'">
        <label [for]="'controlUnit-' + device.id" class="col-sm-5 col-form-label">{{ 'DEVICE.CONTROL_UNIT' | translate
          }}</label>
        <div class="col-sm-7">
          <select class="form-select" [id]="'controlUnit-' + device.id" formControlName="controlUnit" [ngClass]="{'read-only':action === 'edit'}">
            <option>tx1</option>
            <option>tx2</option>
          </select>
          <hbo-control-messages [control]="deviceForm.get('controlUnit')!"></hbo-control-messages>
        </div>
      </div>

      <div class="row mb-3" *ngIf="deviceForm.get('deviceTypeId')?.value === '1'">
        <label [for]="'irLedType-' + device.id" class="col-sm-5 col-form-label">{{ 'DEVICE.IR_LED_TYPE' | translate
          }}</label>
        <div class="col-sm-7">
          <select class="form-select" [id]="'irLedType-' + device.id" formControlName="irLedType" [ngClass]="{'read-only':action === 'edit'}">
            <option>type1 (10 intensity)</option>
            <option>type2 (100 intensity)</option>
          </select>
          <hbo-control-messages [control]="deviceForm.get('irLedType')!"></hbo-control-messages>
        </div>
      </div>

      <div class="row mb-3" *ngIf="deviceForm.get('deviceTypeId')?.value !== '2'">
        <label [for]="'frontendSwVersion-' + device.id" class="col-sm-5 col-form-label">{{ 'DEVICE.FRONTEND_SW_VERSION'
          | translate }}</label>
        <div class="col-sm-7">
          <input type="text" class="form-control" [id]="'frontendSwVersion-' + device.id"
            formControlName="frontendSwVersion" [ngClass]="{'read-only':action === 'edit'}">
          <hbo-control-messages [control]="deviceForm.get('frontendSwVersion')!"></hbo-control-messages>
        </div>
      </div>

      <div class="row mb-3"
        *ngIf="deviceForm.get('deviceTypeId')?.value === '1' || deviceForm.get('deviceTypeId')?.value === '3'">
        <label [for]="'backendSwVersion-' + device.id" class="col-sm-5 col-form-label">{{ 'DEVICE.BACKEND_SW_VERSION' |
          translate }}</label>
        <div class="col-sm-7">
          <input type="text" class="form-control" [id]="'backendSwVersion-' + device.id"
            formControlName="backendSwVersion" [ngClass]="{'read-only':action === 'edit'}">
          <hbo-control-messages [control]="deviceForm.get('backendSwVersion')!"></hbo-control-messages>
        </div>
      </div>

      <div class="row mb-3" *ngIf="deviceForm.get('deviceTypeId')?.value !== '2'">
        <label [for]="'lastActivity-' + device.id" class="col-sm-5 col-form-label">{{ 'DEVICE.LAST_ACTIVITY' | translate
          }}</label>
        <div class="col-sm-7 align_middle">
          <span *ngIf="action ==='edit' && !deviceForm.get('lastActivity')!.value" >-</span>
          <input *ngIf="action === 'create' || (action ==='edit' && deviceForm.get('lastActivity')!.value)" type="datetime-local" class="form-control" [id]="'lastActivity-' + device.id"
            formControlName="lastActivity" [ngClass]="{'read-only':action === 'edit'}">
          <hbo-control-messages [control]="deviceForm.get('lastActivity')!"></hbo-control-messages>
        </div>
      </div>
    </div>
  </div>

  <div class="p-4" *ngIf="user.profileId !== 2 && ( action === 'create' || (action !== 'create' && device?.deviceType?.id !== 3))">
    <button type="button" class="btn btn-outline-secondary me-2" (click)="cancel()">{{ 'COMMON.CANCEL' | translate
      }}</button>
    <button type="submit" class="btn btn-dark">{{ 'COMMON.SAVE_CHANGES' | translate }}</button>
    <button type="button" class="btn btn-outline-secondary float-end" data-bs-toggle="modal"
      [attr.data-bs-target]="'#confirmationModal-' + device.id" *ngIf="user.roleId === 1 && action === 'edit'">
      <i class="bi bi-trash3"></i> {{ 'COMMON.DELETE' | translate }}
    </button>
  </div>
</form>

<hbo-confirmation-modal [id]="device.id" (confirm)="delete()"></hbo-confirmation-modal>
<hbo-confirmation-modal [id]="'change-device-'+device.id" [head]="'COMMON.DEVICE_WILL_BE_CHANGED'"
  [message]="'COMMON.SURE_TO_CONTINUE_DEVICE_CHANGE'" (confirm)="confirmSave()"></hbo-confirmation-modal>